// src/pages/HomePage.js
import React from "react";
import Header from "../components/Header";
import About from "../components/About";
import Offer from "../components/Offer";
import Pricing from "../components/Pricing";
import Faq from "../components/Faq"; // <-- 1. Importuj komponent
import Contact from "../components/Contact";
import Footer from "../components/Footer";
import "../App.css";

function HomePage() {
  return (
    <div className="App">
      <Header />
      <main>
        <About />
        <Offer />
        <Pricing />
        <Faq /> {/* <-- 2. Dodaj go tutaj */}
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

export default HomePage;